/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChildUpdateCompanyQuestion = {
    readonly id?: number;
    name: string;
    question_type?: ChildUpdateCompanyQuestion.question_type;
    options?: Array<string>;
    company: number;
    description?: string | null;
};
export namespace ChildUpdateCompanyQuestion {
    export enum question_type {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
    }
}

